import {Map as olMap, View as olView} from 'ol'
import {Tile as ollayerTile} from 'ol/layer'
import TileGrid from 'ol/tilegrid/TileGrid'
import {WMTS} from 'ol/source'
import 'ol-proj'
import { Coordinate } from 'ol/coordinate'
import { Extent } from 'ol/extent'
import { Renderer } from './Renderer'
import Style from 'ol/style/Style'
import { Styles } from '@/Styles'
import WMTSTileGrid from 'ol/tilegrid/WMTS'

export class IGNRenderer extends Renderer<WMTS> {
  tilegrid: TileGrid
  layer: ollayerTile<WMTS>
  map: olMap
  projection = "EPSG:3857"

  static IsValidForExtent(latLngExtent: Extent) {
    return !(latLngExtent[0] > 8.5 || latLngExtent[1] > 51.5 || latLngExtent[2] < -5 || latLngExtent[3] < 42)
  }

  constructor(type: string, element: string, extentLatLng: Extent, ignKey: string) {
    super(type)

    const resolutions = [
      156543.03392804103,
      78271.5169640205,
      39135.75848201024,
      19567.879241005125,
      9783.939620502562,
      4891.969810251281,
      2445.9849051256406,
      1222.9924525628203,
      611.4962262814101,
      305.74811314070485,
      152.87405657035254,
      76.43702828517625,
      38.218514142588134,
      19.109257071294063,
      9.554628535647034,
      4.777314267823517,
      2.3886571339117584,
      1.1943285669558792,
      0.5971642834779396,
      0.29858214173896974,
      0.14929107086948493,
      0.07464553543474241
    ] ;
    const wmtsTileGrid = new WMTSTileGrid({
      origin: [-20037508,20037508], // topLeftCorner
      resolutions: resolutions, // résolutions
      matrixIds: ["0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19"] // ids des TileMatrix
    })
    this.tilegrid = wmtsTileGrid
    this.layer = new ollayerTile({
      source : new WMTS({
          url: `https://wxs.ign.fr/${ignKey}/geoportail/wmts`,
          layer: "GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2",
          matrixSet: "PM",
          format: "image/png",
          style: "normal",
          tileGrid : wmtsTileGrid,
          attributions:
          '<a href="http://www.ign.fr" target="_blank">' +
          '<img src="https://wxs.ign.fr/static/logos/IGN/IGN.gif" title="Institut national de l\'' +
          'information géographique et forestière" alt="IGN"></a>',  
      })
    })
    
    this.map = this.CreateMap(element, extentLatLng)
  }

  CreateView(centre: Coordinate): olView {
    return new olView({
      center: centre,
      zoom: 10,
      maxZoom: 19
    })
  }
}
